// Versión del front, leída de package.json en tiempo de build (tsconfig ya tiene
// resolveJsonModule + allowSyntheticDefaultImports). Punto único: no repetir el
// import por todo el proyecto.
//
// Uso: en las alertas de ERROR se agrega al pie la versión, en letra chica y
// discreta. Objetivo de soporte: cuando un usuario reporta un error con captura,
// se ve de inmediato si está en una versión vieja por caché.
import pkg from '../../../../package.json';

export const VERSION_FRONT: string = pkg.version;

// HTML del pie (span propio para poder estilarlo sin tocar el .swal2-footer).
const FOOTER_VERSION_HTML = `<span class="swal-version-front">Versión ${VERSION_FRONT}</span>`;

// Clase que se agrega a customClass.footer para el estilo global (_wms-swal.scss).
const CLASE_FOOTER_VERSION = 'swal-version-footer';

type ConfigSwalParcial = {
  icon?: unknown;
  footer?: unknown;
  customClass?: unknown;
};

/**
 * Si la alerta es de ERROR, agrega al pie la versión del front. No-op para
 * cualquier otro icono. Muta y devuelve el mismo objeto de config de SweetAlert2,
 * así se puede envolver el objeto directo en `Swal.fire(pieVersionError({...}))`.
 * Respeta lo que ya venga: concatena el footer y extiende customClass.footer en
 * vez de pisarlos.
 */
export function pieVersionError<T extends ConfigSwalParcial>(config: T): T {
  if (!config || config.icon !== 'error') return config;

  config.footer = config.footer
    ? `${config.footer}<br>${FOOTER_VERSION_HTML}`
    : FOOTER_VERSION_HTML;

  const cc = config.customClass;
  if (typeof cc === 'string') {
    // customClass en forma de string aplica al popup; para el footer se necesita
    // la forma objeto — se preserva el popup original.
    config.customClass = { popup: cc, footer: CLASE_FOOTER_VERSION };
  } else if (cc && typeof cc === 'object') {
    const obj = cc as { footer?: string };
    obj.footer = obj.footer
      ? `${obj.footer} ${CLASE_FOOTER_VERSION}`
      : CLASE_FOOTER_VERSION;
  } else {
    config.customClass = { footer: CLASE_FOOTER_VERSION };
  }

  return config;
}
